import { Box, Flex } from '@joinrepublic/dls-ui-kit';

import { Img, Link, Text } from '@r-client/shared/ui/core';
import { BasicMenuItem } from '@r-client/shared/ui/menu';

import { TEditableEntity } from '../types';
import dummy from './assets/dummy.svg';

import styles from './editable-entities.module.scss';

interface IEditableEntityProps {
  entity: TEditableEntity;
  entityType?: 'teaser' | 'offering';
}

export const EditableEntity = ({
  entity,
  entityType = 'offering',
}: IEditableEntityProps) => {
  return (
    <BasicMenuItem key={entity.id} data-testid="editable-entities-section">
      <Link
        target="_blank"
        rel="nofollow noopener"
        variant={Link.variants.unstyled}
        href={
          entityType === 'offering'
            ? `/${entity.slug}`
            : `/coming-soon/first-look/${entity.slug}/dashboard`
        }
      >
        <Flex alignItems="center" gap="8px">
          <Box>
            <Img
              src={(entity.logoUrl || entity.logoImageUrl) ?? dummy}
              src2x={entity.logoUrl2x ?? dummy}
              className={styles.offeringImage}
            />
          </Box>
          <Box>
            <Text lineHeight="1">{entity.companyName}</Text>
          </Box>
        </Flex>
      </Link>
    </BasicMenuItem>
  );
};
